import React, {Component} from 'react';

import ArchiveTypeSelector from '../common/ArchiveTypeSelector'
import ArchiveCategory from '../common/ArchiveCategory'
import {FormattedMessage} from 'react-intl';
import api from "../../config/api";
import {completeUrls} from "../../util/utils";

class ArchivePage extends Component {

	constructor(props) {
		super(props);

		this.state = {
			archives: [],
			itemTypes: [],
			renderedType: "ALL"
		};
	}

	/**
	 * Load the products on first mount
	 */
	componentWillMount() {
		const {selectedLanguage} = this.props;
		this.loadArchives(selectedLanguage);
		this.loadItemTypes();
	}

	/**
	 * Load other products if the route is changed
	 * @param nextProps - the props that will be received next
	 */
	componentWillReceiveProps(nextProps) {
		const {selectedLanguage, match} = nextProps;
		if (this.props.match.url !== match.url) {
			this.setState({
				archives: [],
				itemTypes: [],
				renderedType: "ALL"
			});
			this.loadArchives(selectedLanguage);
			this.loadItemTypes();
		}
	}

	/**
	 * Load archived products from API
	 * @param language
	 */
	loadArchives = (language) => {
		fetch(api.archive(language.codeCountry))
			.then(res => res.json())
			.then(data => {
				this.setState({archives: completeUrls(data)});
			}).catch(err => console.error(err));

	};

	/**
	 * Load item types from API
	 */
	loadItemTypes = () => {
		fetch(api.itemType)
			.then(res => res.json())
			.then(data => {
				this.setState({itemTypes: data});
			}).catch(err => console.error(err));
	};

	/**
	 *
	 * @param type
	 * @param index
	 * @returns {*}
	 */
	renderProductCategory = (type, index) => {
		const {localizePath} = this.props;
		const products = this.state.archives.filter(product => product.type === type.name);

		if (products.length === 0) {
			return null;
		}

		return (
			<ArchiveCategory rendered={this.state.renderedType}
			                 localizePath={localizePath}
			                 key={index} type={type}
			                 filteredProducts={products}/>
		);
	};

	changeType = (type) => {
		this.setState({renderedType: type});
	};

	/**
	 * Render ProductPage
	 *
	 * @returns {XML}
	 */
	render() {
		const {page} = this.props;
		const {archives, itemTypes} = this.state;
		return (
			<div className="container-flex">
				<h2 className={page.titleClass}>
					<FormattedMessage id={"page.title." + page.title.toLowerCase().replace(" ", "-")}/>
				</h2>
				<div className="page">
					<div className={page.contentClass}>
						<ArchiveTypeSelector itemTypes={itemTypes} products={archives}
						                     rendered={this.state.renderedType}
						                     changeType={this.changeType}/>
						<div className="product-list product-list--main-page">
							{itemTypes.map(this.renderProductCategory)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default ArchivePage;


// WEBPACK FOOTER //
// ./src/components/page/ArchivePage.js